import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import LoadingOverlay from './loading_overlay';
import styled from '../../styles/styled';
import { Theme } from '../../styles';
export function ListView(props) {
    const { columns, data, loading = false, gridTemplateColumns, buildRowTestId = () => { }, onRowClick, canRowClick, linkTo, } = props;
    return (_jsxs(_Fragment, { children: [loading && _jsx(LoadingOverlay, {}), !loading && (_jsx(ListViewGrid, { "data-testid": props['data-testid'], columns: gridTemplateColumns, children: data.map(record => {
                    const handleRowClickProps = {};
                    const clickable = canRowClick?.(record) ?? !!onRowClick;
                    if (clickable && !!onRowClick) {
                        handleRowClickProps.tabIndex = 0;
                        handleRowClickProps.role = 'button';
                        handleRowClickProps.onClick = () => {
                            onRowClick(record);
                        };
                        handleRowClickProps.onKeyDown = (e) => {
                            if (e.key === 'Enter') {
                                onRowClick(record);
                            }
                        };
                    }
                    const RowContainer = ({ children }) => {
                        return linkTo && canRowClick && canRowClick(record) ? (_jsx(ListViewRowLink, { onClick: () => {
                                linkTo(record);
                            }, children: children })) : (_jsx(ListViewRow, { children: children }));
                    };
                    return (_jsx(RowContainer, { "data-testid": buildRowTestId(record), children: columns.map(column => {
                            const handleCellClickProps = {};
                            if (column.onCellClick) {
                                handleCellClickProps.tabIndex = 0;
                                handleCellClickProps.role = 'button';
                                handleCellClickProps.onClick = (e) => {
                                    column.onCellClick(record, e);
                                };
                                handleCellClickProps.onKeyDown = (e) => {
                                    if (e.key === 'Enter') {
                                        column.onCellClick(record, e);
                                    }
                                };
                            }
                            return (_jsx(ListViewCell, { className: 'list-view__cell', "data-testid": `${buildRowTestId(record)}-cell-${column.key}`, ...handleCellClickProps, ...handleRowClickProps, children: column.render(record) }, column.key));
                        }) }, record.key));
                }) }))] }));
}
const ListViewGrid = styled.div(({ columns }) => ({
    display: 'grid',
    gridTemplateColumns: columns ?? '1fr auto auto',
    borderWidth: '0 1px',
    borderStyle: 'solid',
    borderColor: Theme.colors.grey10,
}));
const ListViewRowLink = styled('a')(({ theme }) => ({
    display: 'contents',
    ':hover > .list-view__cell': {
        backgroundColor: theme.colors.lightBlue,
        cursor: 'pointer',
    },
}));
const ListViewRow = styled.div(({ theme }) => ({
    display: 'contents',
    ':hover > .list-view__cell': {
        backgroundColor: theme.colors.lightBlue,
    },
}));
const ListViewCell = styled.div(({ theme, onClick }) => ({
    display: 'flex',
    alignItems: 'center',
    height: '88px',
    padding: `5px ${theme.space[4]}px`,
    fontFamily: theme.text.bodyFontFamily,
    fontSize: theme.text.size.medium,
    color: theme.colors.grey90,
    verticalAlign: 'middle',
    wordBreak: 'break-word',
    backgroundColor: 'none',
    ':hover': {
        cursor: onClick ? 'pointer' : undefined,
    },
    borderBottom: `1px solid ${theme.colors.grey10}`,
}));
//# sourceMappingURL=list_view.js.map